import { CrystalElement, type CraftType, type GatheringType, type SkillTier } from './index'

export const CRAFT_TYPES: ReadonlyArray<{ value: CraftType; label: string; tParam: number }> = [
  { value: 'woodworking', label: '木工', tParam: 0 },
  { value: 'smithing', label: '鍛冶', tParam: 1 },
  { value: 'goldsmithing', label: '彫金', tParam: 2 },
  { value: 'clothcraft', label: '裁縫', tParam: 3 },
  { value: 'leathercraft', label: '革細工', tParam: 4 },
  { value: 'bonecraft', label: '骨細工', tParam: 5 },
  { value: 'alchemy', label: '錬金術', tParam: 6 },
  { value: 'cooking', label: '調理', tParam: 7 },
] as const

export const GATHERING_TYPES: ReadonlyArray<{
  value: GatheringType
  label: string
  future?: boolean
}> = [
  { value: 'mining', label: '採掘' },
  { value: 'excavation', label: '発掘' },
  { value: 'logging', label: '伐採' },
  { value: 'harvesting', label: '収穫' },
  { value: 'chocoboDigging', label: 'チョコボ掘り' },
  { value: 'fishing', label: '釣り' },
] as const

export const SKILL_TIERS: ReadonlyArray<SkillTier> = [
  { index: 0, label: '素人', range: '0〜10', min: 0, max: 10 },
  { index: 1, label: '見習', range: '8〜20', min: 11, max: 20 },
  { index: 2, label: '徒弟', range: '18〜30', min: 21, max: 30 },
  { index: 3, label: '下級', range: '28〜40', min: 31, max: 40 },
  { index: 4, label: '名取', range: '38〜50', min: 41, max: 50 },
  { index: 5, label: '目録', range: '48〜60', min: 51, max: 60 },
  { index: 6, label: '印可', range: '58〜70', min: 61, max: 70 },
  { index: 7, label: '高弟', range: '68〜80', min: 71, max: 80 },
  { index: 8, label: '皆伝', range: '78〜90', min: 81, max: 90 },
  { index: 9, label: '師範', range: '88〜100', min: 91, max: 100 },
  { index: 10, label: '高級', range: '98～110', min: 101, max: 999 },
]

export const CRAFT_TYPE_LABEL: Record<CraftType, string> = Object.fromEntries(
  CRAFT_TYPES.map(({ value, label }) => [value, label])
) as Record<CraftType, string>

export const GATHERING_TYPE_LABEL: Record<GatheringType, string> = Object.fromEntries(
  GATHERING_TYPES.map(({ value, label }) => [value, label])
) as Record<GatheringType, string>

const CRYSTAL_ELEMENT_BY_LABEL: Record<string, CrystalElement> = {
  [CrystalElement.Fire]: CrystalElement.Fire,
  [CrystalElement.Ice]: CrystalElement.Ice,
  [CrystalElement.Wind]: CrystalElement.Wind,
  [CrystalElement.Earth]: CrystalElement.Earth,
  [CrystalElement.Thunder]: CrystalElement.Thunder,
  [CrystalElement.Water]: CrystalElement.Water,
  [CrystalElement.Light]: CrystalElement.Light,
  [CrystalElement.Dark]: CrystalElement.Dark,
}

export const CRYSTAL_ELEMENT_COLOR: Record<CrystalElement, string> = {
  [CrystalElement.Fire]: '#ef5350',
  [CrystalElement.Ice]: '#42a5f5',
  [CrystalElement.Wind]: '#66bb6a',
  [CrystalElement.Earth]: '#a1887f',
  [CrystalElement.Thunder]: '#ffee58',
  [CrystalElement.Water]: '#26c6da',
  [CrystalElement.Light]: '#fff9c4',
  [CrystalElement.Dark]: '#7e57c2',
}

export function getCrystalElement(crystal: string): CrystalElement | null {
  return CRYSTAL_ELEMENT_BY_LABEL[crystal] ?? null
}

export function getCrystalColor(crystal: string): string {
  const element = getCrystalElement(crystal)
  return element ? CRYSTAL_ELEMENT_COLOR[element] : '#e0e0e0'
}

export function shouldUseDarkCrystalText(crystal: string): boolean {
  const element = getCrystalElement(crystal)
  return element === CrystalElement.Light || element === CrystalElement.Thunder
}

export const CRAFT_LABEL_TO_TYPE: Record<string, CraftType> = Object.fromEntries(
  CRAFT_TYPES.map(({ value, label }) => [label, value])
) as Record<string, CraftType>
